export default __webpack_public_path__ + "static/media/upee_distribution_b.49054d4c.webp";